import type {Item} from 'shells/table/setup-item-table';

import type {GetProductsCategories_productCategories as ProductCategory} from 'nutshell-graphql-types';

import {addNotification} from '../../notifications/index';

export function mapCategoriesToTableItems(categories: Array<ProductCategory>): Item[] {
    return categories.map((category) => ({
        // @ts-expect-error
        id: category.id,
        // @ts-expect-error
        name: category.name,
        // @ts-expect-error
        createdTime: category.createdTime,
        // @ts-expect-error
        numAssociatedProducts: category.numAssociatedProducts,
        // @ts-expect-error
        reportLink: category.reportLink,
        isDeleteable: true,
        isEditable: true,
        ...category,
    }));
}

function getSuccessNotificationBodyText(
    productCategory: ProductCategory,
    didDeleteProducts: boolean
): string {
    return didDeleteProducts
        ? `${productCategory.name} and its products have been deleted.`
        : `${productCategory.name} and its products have been uncategorized.`;
}

export function notifyUser(data: ProductCategory, didDeleteProducts: boolean) {
    if (!data) {
        throw new Error('Response data is missing');
    }

    const bodyText = getSuccessNotificationBodyText(data, didDeleteProducts);

    addNotification('Deletion successful', {
        body: bodyText,
        icon: 'archive',
    });
}
